import React, { useState, useEffect } from 'react';
import { COLORS, SPACING } from '../styles/theme';
import { getNotifications, markRead, markAllRead, addNotificationsListener, NotificationRecord } from '../lib/notifications';

const TYPE_ICONS: Record<NotificationRecord['type'], string> = {
  dm: '✉',
  reply: '↩',
  like: '♥',
  takedown: '⚠',
};

interface NotificationsProps {
  onBack: () => void;
  onNavigate: (n: NotificationRecord) => void;
}

export function Notifications({ onBack, onNavigate }: NotificationsProps) {
  const [notifications, setNotifications] = useState<NotificationRecord[]>(() => getNotifications());

  useEffect(() => addNotificationsListener(() => setNotifications(getNotifications())), []);

  const handleClick = (n: NotificationRecord) => {
    markRead(n.id);
    onNavigate(n);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ padding: SPACING.lg, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: SPACING.md, flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: SPACING.md }}>
          <button
            onClick={onBack}
            style={{ background: 'none', border: 'none', color: COLORS.highlight, cursor: 'pointer', fontFamily: '"IBM Plex Mono", monospace', fontSize: '17px', padding: 0 }}
          >
            ← back
          </button>
          <span style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: '17px', color: COLORS.text, fontWeight: 700 }}>
            Notifications
          </span>
        </div>
        {notifications.some(n => !n.read) && (
          <button
            onClick={() => markAllRead()}
            style={{ background: 'none', border: `1px solid ${COLORS.border}`, color: COLORS.textMuted, cursor: 'pointer', padding: `${SPACING.sm} ${SPACING.md}`, fontFamily: '"IBM Plex Mono", monospace', fontSize: '12px' }}
          >
            mark all read
          </button>
        )}
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: SPACING.lg }}>
        {notifications.length === 0 ? (
          <p style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: '14px', color: COLORS.textMuted }}>
            No notifications yet.
          </p>
        ) : (
          notifications.map(n => (
            <div
              key={n.id}
              onClick={() => handleClick(n)}
              style={{
                border: `1px solid ${COLORS.border}`,
                borderLeft: n.read ? `1px solid ${COLORS.border}` : `3px solid ${COLORS.accent}`,
                padding: SPACING.lg,
                marginBottom: SPACING.sm,
                backgroundColor: n.read ? COLORS.panel : COLORS.bg,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'flex-start',
                gap: SPACING.md,
              }}
            >
              <span style={{ fontSize: '20px', color: COLORS.accent, lineHeight: 1.4 }}>{TYPE_ICONS[n.type]}</span>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: '14px', color: COLORS.text, margin: 0 }}>
                  {n.text}
                </p>
                <span style={{ fontFamily: '"IBM Plex Mono", monospace', fontSize: '11px', color: COLORS.textMuted }}>
                  {new Date(n.createdAt).toLocaleString()}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
